module.exports = __webpack_public_path__ + "img/payment-method-fpx.aab812ca.png";